/**
 * Shared configuration and utility functions
 */
/**
 * Check if the current time is after 9pm PST on February 22, 2026
 * This is the time when the Challenge window opens
 */
export const isChallengeWindowOpen = () => {
    const now = new Date();
    // February 22, 2026 at 9:00 PM PST (which is February 23, 2026 at 5:00 AM UTC)
    const challengeOpenDate = new Date('2026-02-22T21:00:00-08:00');
    return now.getTime() > challengeOpenDate.getTime();
};
